import { Box, BoxProps, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import LoadingSpinner from "./LoadingSpinner";
import { SxProps } from "@mui/system";
import { useTranslation } from "react-i18next";

type Props = {
  isLoading: boolean;
  ContainerProps?: BoxProps;
  loadingSpinnerSx?: SxProps;
  emptyStateContent?: string | JSX.Element;
  emptyStateCondition?: boolean;
};

const renderEmptyStateContent = (content: string | JSX.Element) => {
  if (typeof content === "string")
    return <Typography my={2}>{content}</Typography>;

  return content;
};

const AsyncContentSelector = ({
  isLoading,
  ContainerProps = {},
  loadingSpinnerSx = {},
  emptyStateContent,
  emptyStateCondition = false,
  children,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ minHeight: "72px", position: "relative", ...ContainerProps.sx }}>
      {isLoading ? (
        <LoadingSpinner
          sx={{
            position: "absolute",
            top: "0",
            ...loadingSpinnerSx,
          }}
        />
      ) : emptyStateCondition ? (
        renderEmptyStateContent(emptyStateContent || t("common:noItems"))
      ) : (
        children
      )}
    </Box>
  );
};

export default AsyncContentSelector;
